class GCSUploadError extends Error {
  detail: string;
  status: number;

  constructor({ detail, status }: { detail: string; status: number }, ...params: any) {
    super(...params);

    this.name = 'GCSUploadError';
    this.detail = detail;
    this.status = status;
  }
}

export type GCSUploadOptions = {
  url: string;
  fields: Record<string, string>;
};

export async function uploadToGCS(file: File, json: GCSUploadOptions) {
  let data = new FormData();

  Object.keys(json.fields).forEach((key: keyof GCSUploadOptions['fields']) => {
    data.append(key, json.fields[key]);
  });

  data.append('file', file);

  let parser = new DOMParser();
  let { url } = json;

  let response = await fetch(url, {
    method: 'POST',
    body: data,
  });

  let text = await response.text();
  let xml = parser.parseFromString(text, 'text/xml');

  if (response.ok) {
    // We run encodeURI on the result, because GCS re-encodes filenames itself
    // after uploading, even though we do that ourselves earlier. Their
    // re-encoding can lead to the end result filename being slightly different
    // than our expectation.
    // For example: when we encode the filename, a space gets converted to %20.
    // That will end up as %2520 in GCS, because the % character will get
    // encoded into %25.
    return { key: encodeURI(`${json.url}${json.fields.key}`) };
  } else {
    let detail =
      xml?.getElementsByTagName('Message')?.[0]?.textContent ??
      'Something went wrong while uploading to Google Cloud Storage.';
    throw new GCSUploadError(
      {
        detail,
        status: response.status,
      },
      text,
    );
  }
}
